import ScreenLoader from "components/ScreenLoader";
import React, { FC, memo, Suspense } from "react";

interface Props {
  children?: React.ReactNode;
}

const LazyLoader: FC<Props> = ({ children }) => {
  return <Suspense fallback={<ScreenLoader isScreenLoader={true} />}>{children}</Suspense>;
};

export default memo(LazyLoader);
